<template>

  	<div class="content_support" v-if="proofLoginStatus">

	  	<ul class="subnav-ticket">
	  		<li class="gruen1">
	  			<router-link to="/create-ticket" class="nav-item nav-link gruen1" active-class="active_ticket" role="link" style="font-weight:bold;">Ticket erstellen</router-link>
	  		</li>
	  		<li>
		  		<a href="#" @click="filterTickets('all')" v-if="showOpenTickets">alle Tickets</a>
		  		<a href="#" @click="filterTickets('open')" v-else>offene Tickets</a>
		  	</li>
		  	<!-- <li>
		  		<a href="/support/" target="_blank">Hilfecenter durchsuchen</a>
		  	</li> -->
		</ul>

		<table v-if="showOpenTickets" style="margin-top:25px;" class="ticketlist">
			<tr class="head">
				<th>ID</th>
				<th>Betreff</th>
				<th>Priorität</th>
				<th>Status</th>
				<th>letzter Beitrag</th>
			</tr>
			<tr v-for="(item, $index) of openTickets" @click="showTicket(item.id)">
				<td>
					<span v-if="item.state_id == '2' || item.state_id == '1'" style="font-weight:bold;">
						#{{item.number}}
					</span>
		        	<span v-else>
						#{{item.number}}
					</span>
				</td>
				<td>
					<span v-if="item.state_id == '2' || item.state_id == '1'" style="font-weight:bold;">
						{{item.title}}<br/><span style="color:#9a9a9a">{{item.note}}</span>
					</span>
		        	<span v-else>
						{{item.title}}<br/><span style="color:#9a9a9a">{{item.note}}</span>
					</span>					
				</td>
				<td>
		            <span v-if="item.priority_id == '1'">
						<span v-if="item.state_id == '2' || item.state_id == '1'" style="font-weight:bold;">
							Niedrig
						</span>
			        	<span v-else>
							Niedrig
						</span>		
		            </span>
		            <span v-else-if="item.priority_id == '2'">
						<span v-if="item.state_id == '2' || item.state_id == '1'" style="font-weight:bold;">
							Mittel
						</span>
			        	<span v-else>
							Mittel
						</span>
		            </span>
		            <span v-else-if="item.priority_id == '3'">
						<span v-if="item.state_id == '2' || item.state_id == '1'" style="font-weight:bold;">
							Hoch
						</span>
			        	<span v-else>
							Hoch
						</span>
		            </span>
		            <span v-else>
						<span v-if="item.state_id == '2' || item.state_id == '1'" style="font-weight:bold;">
							N/A
						</span>
			        	<span v-else>
							N/A
						</span>
		            </span>
	        	</td>
				<td>
		            <span v-if="item.state_id == '2'" style="font-weight:bold;">
		               Offen
		            </span>
		            <span v-else-if="item.state_id == '1'" style="font-weight:bold;">
		               Neu
		            </span>
		            <span v-else-if="item.state_id == '4'">
		               Geschlossen
		            </span>
		            <span v-else-if="item.state_id == '3'">
		               Warten auf Erinnerung
		            </span>
		            <span v-else-if="item.state_id == '7'">
		               Warten auf schließen
		            </span>
		            <span v-else>
		               Status: N/A
		            </span>
	        	</td>
	        	<td>
	        		<span v-if="item.state_id == '2' || item.state_id == '1'" style="font-weight:bold;">
						{{ item.updated_at | formatDate }}
					</span>
	        		<span v-else>
						{{ item.updated_at | formatDate }}
					</span>
	        	</td>
			</tr>
		</table>

		<table v-else-if="tickets" style="margin-top:25px;" class="ticketlist">
			<tr class="head">
				<th>ID</th>
				<th>Betreff</th>
				<th>Priorität</th>
				<th>Status</th>
				<th>letzter Beitrag</th>
				<th>letzter Bearbeiter</th>
			</tr>
			<tr v-for="(item, $index) of tickets" @click="showTicket(item.id)">
				<td>
					<span v-if="item.state_id == '2' || item.state_id == '1'" style="font-weight:bold;">
						#{{item.number}}
					</span>
		        	<span v-else>
						#{{item.number}}
					</span>
				</td>		
				<td>
					<span v-if="item.state_id == '2' || item.state_id == '1'" style="font-weight:bold;">
						{{item.title}}<br/><span style="color:#9a9a9a">{{item.note}}</span>
					</span>
		        	<span v-else>
						{{item.title}}<br/><span style="color:#9a9a9a">{{item.note}}</span>
					</span>
				</td>
				<td>
		            <span v-if="item.priority_id == '1'">
						<span v-if="item.state_id == '2' || item.state_id == '1'" style="font-weight:bold;">
							Niedrig
						</span>
			        	<span v-else>
							Niedrig
						</span>		
		            </span>
		            <span v-else-if="item.priority_id == '2'">
						<span v-if="item.state_id == '2' || item.state_id == '1'" style="font-weight:bold;">
							Mittel
						</span>
			        	<span v-else>
							Mittel
						</span>
		            </span>
		            <span v-else-if="item.priority_id == '3'">
						<span v-if="item.state_id == '2' || item.state_id == '1'" style="font-weight:bold;">
							Hoch
						</span>
			        	<span v-else>
							Hoch
						</span>
		            </span>
		            <span v-else>
						<span v-if="item.state_id == '2' || item.state_id == '1'" style="font-weight:bold;">
							N/A
						</span>
			        	<span v-else>
							N/A
						</span>
		            </span>
	        	</td>
				<td>
		            <span v-if="item.state_id == '2'" style="font-weight:bold;">
		               Offen
		            </span>
		            <span v-else-if="item.state_id == '1'" style="font-weight:bold;">
		               Neu
		            </span>
		            <span v-else-if="item.state_id == '4'">
		               Geschlossen
		            </span>
		            <span v-else-if="item.state_id == '3'">
		               Warten auf Erinnerung
		            </span>
		            <span v-else-if="item.state_id == '7'">
		               Warten auf schließen
		            </span>
		            <span v-else>
		               Status: N/A
		            </span>
	        	</td>
	        	<td>
	        		<span v-if="item.state_id == '2' || item.state_id == '1'" style="font-weight:bold;">
						{{ item.updated_at | formatDate }}
					</span>
	        		<span v-else>
						{{ item.updated_at | formatDate }}
					</span>
	        	</td>
	        	<td>
	        		<span v-if="item.state_id == '2' || item.state_id == '1'" style="font-weight:bold;">
	        			{{ agent(item.owner_id) }}
	        		</span>
	        		<span v-else>
	        			{{ agent(item.owner_id) }}
	        		</span>
	        	</td>
			</tr>
		</table>

		<div v-else style="margin-top:25px;">
			Noch keine Tickets vorhanden.
		</div>



		<!-- <ul v-if="showOpenTickets" style="margin-top:25px;" class="ticketlist">
			<li v-for="(item, $index) of openTickets" @click="showTicket(item.id)">
				#{{item.number}}<br/>
                Titel: {{item.title}}<br/>
                Kategorie: {{item.note}}<br/>
	            <span v-if="item.priority_id == '1'">
	               Priorität: Niedrig
	            </span>
	            <span v-else-if="item.priority_id == '2'">
	               Priorität: Mittel
	            </span>
	            <span v-else-if="item.priority_id == '3'">
	               Priorität: Hoch
	            </span>
	            <span v-else>
	               Priorität: N/A
	            </span><br/>
	            <span v-if="item.state_id == '2'">
	               Status: Offen
	            </span>
	            <span v-else-if="item.state_id == '1'">
	               Status: Neu
	            </span>
	            <span v-else-if="item.state_id == '4'">
	               Status: Geschlossen
	            </span>
	            <span v-else-if="item.state_id == '3'">
	               Status: Warten auf Erinnerung
	            </span>
	            <span v-else-if="item.state_id == '7'">
	               Status: Warten auf schließen
	            </span>
	            <span v-else>
	               Status: N/A
	            </span>
            </li>			
		</ul>
		<ul v-else-if="tickets" style="margin-top:25px;" class="ticketlist">
			<li v-for="(item, $index) of tickets" @click="showTicket(item.id)">
				#{{item.number}}<br/>
                Titel: {{item.title}}<br/>
                Kategorie: {{item.note}}<br/>
	            <span v-if="item.priority_id == '1'">
	               Priorität: Niedrig
	            </span>
	            <span v-else-if="item.priority_id == '2'">
	               Priorität: Mittel
	            </span>
	            <span v-else-if="item.priority_id == '3'">
	               Priorität: Hoch
	            </span>
	            <span v-else>
	               Priorität: N/A
	            </span><br/>
	            <span v-if="item.state_id == '2'">
	               Status: Offen
	            </span>
	            <span v-else-if="item.state_id == '1'">
	               Status: Neu
	            </span>
	            <span v-else-if="item.state_id == '4'">
	               Status: Geschlossen
	            </span>
	            <span v-else-if="item.state_id == '3'">
	               Status: Warten auf Erinnerung
	            </span>
	            <span v-else-if="item.state_id == '7'">
	               Status: Warten auf schließen
	            </span>
	            <span v-else>
	               Status: N/A
	            </span>
            </li>
		</ul>
		<div v-else style="margin-top:25px;">
			Noch keine Tickets vorhanden.
		</div> -->

	</div>

</template>

<script>

import TicketSingleView from './TicketSingleView'

export default {
	data() {
		return {
			apiResponse: '', // initial loading or error messages.
			wpPosts: [], // REST API response data goes here.
			wpData, // global data made available via wp_localize_script.
			isDataAvailable: false,
			openTickets: [],
			showOpenTickets: false
		};
	},

	beforeMount() {
		//this.isLoggedIn();
		//this.listTickets();
		// for (var i = 1; i < 4; i++) {
  //     		this.listTickets(i);
  //     	}
	},

	mounted() {

	},

	computed: {
      	proofLoginStatus() {
      		if (this.$store.getters.getZammadToken != "" && this.$store.getters.getZammadID != "" && this.$store.getters.isLoggedIn != "") {
      			for (var i = 1; i < 10; i++) {
      				this.listTickets(i);
      			}

      			//console.log(this.$store.getters.getCurrentPage);

      			//this.listTickets(1);
      			//this.listTickets(2);
      			return true
      		} else {
      			this.$router.push('/noAccess');
      		}
      	},
      	tickets() {

      		var tickets = this.$store.getters.getAllUserTickets;

      		console.log(tickets);
      		//console.log(tickets['page1']);
      		//console.log(tickets.page2);

      		// var temp_ticketPages = []
      		// for (var i = 0; i < 100; i++) {
      		// 	temp_ticketPages.push(tickets.page1[i]);
      		// }
      		// for (var i = 0; i < 53; i++) {
      		// 	temp_ticketPages.push(tickets.page2[i]);
      		// }

      		// console.log(temp_ticketPages);

      		// var tickets_neu = tickets.page1.concat(tickets.page2);
      		// console.log(tickets_neu);

      		//console.log(tickets.page4)
      		//console.log(tickets.page5)

      		var array1 = tickets.page8
      		var array2 = tickets.page7

      		var test = array1.concat(array2)
      		//console.log(test)

      		if (tickets.page8.length > 0) {
      			tickets = test
      		} else if (tickets.page7.length > 0) {
      			tickets = tickets.page7
      		} else if (tickets.page6.length > 0) {
      			tickets = tickets.page6
      		} else if (tickets.page5.length > 0) {
      			tickets = tickets.page5
      		} else if (tickets.page4.length > 0) {
      			tickets = tickets.page4
      		} else if (tickets.page3.length > 0) {
      			tickets = tickets.page3
      		} else if (tickets.page2.length > 0) {
      			tickets = tickets.page2
      		} else {
      			tickets = tickets.page1
      		}

      		//return tickets.page2;

	      	if (tickets.length > 0) {
				tickets.sort(function (a, b) {
					return b.id - a.id;
				});
				return tickets;
	      	} else {
	      		return false;
	      	}
     
      	}
	},

	methods: {

		// testfunction(user_id) {
		// 	var data = {
		// 		'user_id': user_id,
	 //            'nonce': this.wpData.nonce,
	 //            'restURL': this.wpData.rest_url,
	 //            'zammad_token': this.$store.getters.getZammadToken
	 //        }
		// 	this.$store.dispatch('getUser', data)
		//         .then(resp => {
		//         	console.log(resp.data)
		//         	var vorname = resp.data.firstname
		//         	var lastname = resp.data.lastname
		//         	return vorname
		//         })
		//         .catch(err => {
		//            	return ""
		//         })
		// },

      	agent(id) {
		    var agents = this.$store.getters.getAgents;
		    var bearbeiter = "-"
			agents.forEach((element) => {
				if (element.id == id) {
					bearbeiter = element.name
				}
			});
			return bearbeiter
      	},

		isLoggedIn() {
			var user_id = 0
			var data = {
	            'nonce': this.wpData.nonce,
	            'restURL': this.wpData.rest_url
	        }
			this.$store.dispatch('isLoggedIn', data)
		        .then(resp => {
		            if (resp.data.user_id != 0) {
		            	console.log("Angemeldet!");
		            } else {
		            	console.log("Nicht Angemeldet!");
		            }
		        })
		        .catch(err => {
		           	console.log(err)
		           	console.log("Nicht Angemeldet!");
		        })			
		},

		listTickets(page) {
			var data = {
	            'nonce': this.wpData.nonce,
	            'restURL': this.wpData.rest_url,
	            'zammad_token': this.$store.getters.getZammadToken,
	            'page': page
	        }
			this.$store.dispatch('listTickets', data)
		        .then(resp => {
		        	if (resp.data.code != 200) {
		        		console.log("Tickets konnten nicht geladen werden ...")
		        	}
		        })
		        .catch(err => {
		           	console.log(err)
		        })
		},

		showTicket(ticketID) {
			this.$store.commit('setLoadingWorkingScreen')
			this.$router.push({
				name: 'TicketSingleView',
				params: {
					ticket_id: ticketID
				}
			})
		},

		filterTickets(typ) {
			this.openTickets = []

      		var array1 = this.$store.getters.getAllUserTickets.page8;
      		var array2 = this.$store.getters.getAllUserTickets.page7;

      		var tickets = array1.concat(array2)
			//var tickets = this.$store.getters.getAllUserTickets.page7;
			
			if (typ == "open") {
				tickets.forEach((element) => {
					if (element.state_id == 1 || element.state_id == 2) {
						this.openTickets.push(element)
					}
				});
				this.showOpenTickets = true

			} else {
				this.openTickets = tickets
				this.showOpenTickets = false
			}
		},

    	// testStore() {
    	// 	var data = {
     //            'nonce': this.wpData.nonce,
     //            'restURL': this.wpData.rest_url
     //        }
	    // 	// const nonce = this.wpData.nonce
	    // 	// const restURL = this.wpData.rest_url
	    //   	this.$store.dispatch('test', data)
	    //     	.then(resp => {
	    //         	console.log(resp)
	    //     	})
	    //     	.catch(err => {
	    //        		console.log(err)
	    //     	})
    	// },

    	// updateUserMeta() {
    	// 	var data = {
    	// 		'user_id': 1,
    	// 		'zammad_token': 'random1234',
     //            'nonce': this.wpData.nonce,
     //            'restURL': this.wpData.rest_url
     //        }
	    // 	// const nonce = this.wpData.nonce
	    // 	// const restURL = this.wpData.rest_url
	    //   	this.$store.dispatch('updateUserMeta', data)
	    //     	.then(resp => {
	    //         	console.log(resp)
	    //     	})
	    //     	.catch(err => {
	    //        		console.log(err)
	    //     	})
    	// },

	}
};
</script>

<style scoped>

table.ticketlist {
	width: 100%;
}

table.ticketlist tr.head {
	border-bottom: 1px solid #002846;
}

table.ticketlist tr.head th {
	font-weight: bold;
	color: #fff;
	padding: 12px;
	padding-top: 8px;
	padding-bottom: 8px;
}

table.ticketlist tr td {
	padding: 12px;
	padding-bottom: 20px;
	padding-top: 20px;
}

table.ticketlist tr:nth-child(even) {
	background-color: #f5f5f5;
}

table.ticketlist tr:hover {
  background-color: #c9e6f1;
  cursor: pointer;
}

table.ticketlist tr.head, table.ticketlist tr.head:hover {
  background-color: #002846;
  cursor: default;
}

ul.ticketlist li {
   border-bottom:1px solid #ccc;
   padding-bottom:20px;
   padding-top:20px;
   padding-left: 20px;
	cursor:pointer;
}

ul.ticketlist li:nth-child(1) {
	border-top:1px solid #ccc;
}

ul.ticketlist li:nth-child(odd) {
   background-color: #f5f5f5;
}

</style>


// WEBPACK FOOTER //
// src/components/Startseite.vue